import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    INVOICES: {
        URI: () => '/api/v1/reporter-invoices/{{id?}}',
        methods: ['get'],
        default: null,
    },
    INVOICES_SETTLE: {
        URI: () => '/api/v1/reporter-invoices/{{id}}/settle',
        methods: ['put'],
        cacheToClear: ['/api/v1/reporter-invoices'],
        default: {},
    },
    INVOICES_ABANDON: {
        URI: () => '/api/v1/reporter-invoices/{{id}}/abandon',
        methods: ['put'],
        cacheToClear: ['/api/v1/reporter-invoices'],
        default: {},
    },
    REPORTERS_INVOICES: {
        URI: () => '/api/v1/reporters/{{id}}/invoices',
        cacheToClear: ['/api/v1/reporter-invoices'],
        methods: ['post'],
    },
    REPORTERS_CAMPAIGNS: {
        URI: () => '/api/v1/reporters/{{id}}/campaigns',
        methods: ['get'],
    },
    CAMPAIGN_SETTLEMENTS: {
        URI: () => '/api/v1/reporters/{{id}}/campaign-settlements',
        methods: ['get'],
    },
    SETTLEMENTS: {
        URI: () => '/api/v1/campaign-settlements',
        methods: ['get'],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
